import { render, staticRenderFns } from "./DokumenLainLain.vue?vue&type=template&id=1a00ac25"
import script from "./DokumenLainLain.vue?vue&type=script&lang=js"
export * from "./DokumenLainLain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports